theme.counter__Number = (function () {
  class CounterNumber {
    constructor(section) {
      this.container = section;
      this.counterElements = this.container.querySelectorAll('.counter-stats__number');
      this.animated = false;
      this.init();
    }

    init() {
      var enabled =
        this.container.dataset.enableCounter !== 'false' &&
        String(this.container.dataset.enableCounter).toLowerCase() !== 'false';

      if (!enabled) {
        this.counterElements.forEach(function (el) {
          var raw = String(el.dataset.counter || '').trim();
          var anim = new CounterAnimation(el, raw);
          el.textContent = anim.formatNumber(anim.targetNumber) + anim.suffix;
        });
        return;
      }

      // Observe the grid (content box) so counting starts when that enters the viewport, not on page load above the fold.
      var observeEl =
        this.container.querySelector('.counter-stats__grid') || this.container;

      this.observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(
            function (entry) {
              if (entry.isIntersecting && !this.animated) {
                this.startCounters();
                this.animated = true;
                if (this.observer && observeEl) {
                  this.observer.unobserve(observeEl);
                }
              }
            }.bind(this)
          );
        }.bind(this),
        {
          root: null,
          // Require a slice of the block to be visible; negative rootMargin pulls the trigger line up so it fires on scroll-in, not edge-of-screen.
          threshold: 0.15,
          rootMargin: '0px 0px -12% 0px',
        }
      );

      this.observer.observe(observeEl);
    }

    startCounters() {
      this.counterElements.forEach(function (el) {
        var raw = String(el.dataset.counter || '').trim();
        var anim = new CounterAnimation(el, raw);
        anim.start();
      });
    }

    onUnload() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }
  }

  class CounterAnimation {
    constructor(element, rawTarget) {
      this.element = element;

      var m = String(rawTarget).match(/^(\d+(?:\.\d+)?)(.*)$/);
      var numericPart = m ? m[1] : '0';
      this.suffix = m ? m[2].trim() : '';

      this.targetNumber = parseFloat(numericPart) || 0;
      this.currentNumber = 0;

      this.increment = Math.ceil(this.targetNumber / 100) || 1;
      this.interval = 20;
    }

    start() {
      var self = this;
      var timer = setInterval(function () {
        self.currentNumber += self.increment;
        if (self.currentNumber >= self.targetNumber) {
          self.currentNumber = self.targetNumber;
          clearInterval(timer);
        }
        self.element.textContent =
          self.formatNumber(self.currentNumber) + self.suffix;
      }, this.interval);
    }

    formatNumber(num) {
      if (num >= 1000000) {
        return (num / 1000000).toFixed(1) + 'M';
      } else if (num >= 1000) {
        return (num / 1000).toFixed(1) + 'K';
      }
      return String(Math.floor(num));
    }
  }

  return CounterNumber;
})();
